<mat-card
    class="product-info-card" [ngClass]="{'default-card': !isCategoryCard, 'category-card': isCategoryCard, 'no-hover-transform': disableHoverTransform}">
  <div class="card-info" [routerLink]="(isCategoryCard && isDisplay) ? null : (isCategoryCard ? ['/category', id] : ['/product-details', id])" [state]="{isViewAll: isViewAll}">
    <img *ngIf="!isCategoryCard && newBadge" src="assets/images/new.svg" alt="New Badge" class="new-badge">
    <img mat-card-image [src]="productImage" alt="Product Image" class="logo">
    <mat-card-title class="d-none d-md-block d-lg-block">{{ title | truncateText: 18 }}</mat-card-title>
    <mat-card-title class="d-md-none d-lg-none">{{ title | truncateText: 25 }}</mat-card-title>
    <mat-card-subtitle *ngIf="!isCategoryCard">
      <img [src]="subtitleImage" alt="logo" style="height: 3rem; width:4rem;">
    </mat-card-subtitle>
    <mat-card-content *ngIf="!isCategoryCard" class="card-content1">
      <ul>
        <li *ngFor="let item of contentItems?.slice(0, 3)" style="font-size: 10px;">
           {{ item.name }} :&nbsp;
          <span *ngIf="item.value" class="d-none d-md-block d-lg-block"> {{item.value.length>18? item.value.slice(0,18)+'...':item.value}}</span>
          <span *ngIf="item.value" class=" d-md-none d-lg-none"> {{item.value.length>30? item.value.slice(0,30)+'...':item.value}}</span>
          <span *ngIf="item.fromValue" class="d-none d-md-block d-lg-block"> {{ item.fromValue.length>18? item.fromValue.slice(0, 18) + '...' : item.fromValue }} {{ item.fromUnit }}</span>
          <span *ngIf="item.fromValue" class=" d-md-none d-lg-none"> {{ item.fromValue.length>30? item.fromValue.slice(0, 30) + '...' : item.fromValue }} {{ item.fromUnit }}</span>
        </li>
      </ul>
    </mat-card-content>
    <mat-card-content *ngIf="isCategoryCard" class="card-content2">
      <ul *ngIf="!isDisplay" >
        <li *ngIf="subcategories.length === 0">
          Products: {{ productCount }}
        </li>
        <li *ngIf="subcategories.length > 0">
          Sub Categories: {{ subcategories.length }}
        </li>
      </ul>
    </mat-card-content>
  </div>
  <div *ngIf="!isCategoryCard" class="hover-overlay">
    <div class="hover-text">
      <p class="description" [innerHTML]="hoverText"></p>
    </div>
    <div class="hover-buttons">
      <button class="view-more d-flex align-items-center" [routerLink]="['/product-details', id]">
        <img src="assets/images/angle-arrow-small-right.svg" alt=""> <b>View More</b>
      </button>
      <button class="request-quote" (click)="$event.stopPropagation(); checkUserLoginorNot(id)">
        <img src="assets/images/angle-arrow-small-right.svg" alt=""> <b>Product Enquiry</b>
      </button>
    </div>
  </div>
</mat-card>